export default __webpack_public_path__ + "static/media/southernilcabins.f5ad6d41.png";